import { CALCULATOR_TYPE } from 'src/common/constants';
import { API_ENDPOINTS } from 'src/setup/client/api-endpoints';
import HttpClient from 'src/setup/client/http-client';
import {
    FutureSymbolPositionsPayload,
    FutureOrderPayload,
    FutureSymbolSettingsPayload,
    CancelOrderPayload,
    RiskLimitPayload,
    SetStopProfitLossPayLoad,
    StopProfitLossPayLoad,
    CalculatorQueryParamsType,
    ModifyPositionMarginPayLoad,
    GetLeveragePayload,
    SetLeveragePayload,
} from 'src/types';

// API calls for fetching server data
export function fetchFundingRate(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.FUNDING_RATES}?${queryParams}`);
}

// API calls for fetching wallet balances
export function fetchAvailableAssets() {
    return HttpClient.get(API_ENDPOINTS.AVAILABLE_FUTURE_ASSETS);
}

// API calls for fetching symbol settings
export function fetchSymbolSettings(body: Object) {
    return HttpClient.post(API_ENDPOINTS.GET_FUTURE_ORDER_SETTING, body);
}

// API calls for fetching symbol positions
export function fetchSymbolPositions(body: FutureSymbolPositionsPayload) {
    return HttpClient.post(API_ENDPOINTS.FUTURE_POSITIONS, body);
}

// API calls to create order
export function createOrder(body: FutureOrderPayload) {
    return HttpClient.post(`${API_ENDPOINTS.CREATE_FUTURE_ORDER}`, body);
}

// API calls to set symbol settings
export function setSymbolSettings(body: FutureSymbolSettingsPayload) {
    return HttpClient.post(`${API_ENDPOINTS.SET_FUTURE_ORDER_SETTING}`, body);
}

export function fetchPositions() {
    return HttpClient.get(API_ENDPOINTS.ORDER_POSITIONS);
}

export function fetchOpenOrders(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.FUTURE_OPEN_ORDERS}?${queryParams}`);
}

export function fetchTradeOrders(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.FUTURE_TRADE_ORDERS}?${queryParams}`);
}

export function fetchMyTrades(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.FUTURE_MY_TRADES}?${queryParams}`);
}

export function cancelOrder(body: CancelOrderPayload) {
    return HttpClient.post(`${API_ENDPOINTS.CANCEL_ORDER}`, body);
}

// API calls to fetch kline history
export function klineHistory(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.KLINE_HISTORY}?${queryParams}`);
}

// API calls to fetch index kline history
export function indexKlineHistory(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.INDEX_KLINE_HISTORY}?${queryParams}`);
}

// API calls to fetch server time
export function getServerTime() {
    return HttpClient.get(`${API_ENDPOINTS.SERVER_TIME}`);
}

// API calls to set risk limit
export function setRiskLimit(body: RiskLimitPayload) {
    return HttpClient.post(`${API_ENDPOINTS.SET_RISK_LIMIT}`, body);
}

// API calls to calculate ror (rate of return) or elp (estimated liquidation price)
export function performCalculations(queryParams: CalculatorQueryParamsType) {
    return HttpClient.get(
        `${[
            queryParams.calculatorType === CALCULATOR_TYPE.ROR
                ? API_ENDPOINTS.CALCULATE_PROFIT_INFO
                : API_ENDPOINTS.CALCULATE_LIQUIDATION_PRICE,
        ]}`,
        { params: queryParams },
    );
}

// API calls to get position stop and loss
export function fetchPositionStopProfitLoss(body: StopProfitLossPayLoad) {
    return HttpClient.post(`${API_ENDPOINTS.GET_POSITION_STOP_PROFIT_LOSS}`, body);
}

// API calls to set position stop and loss
export function setPositionStopProfitLoss(body: SetStopProfitLossPayLoad) {
    return HttpClient.post(`${API_ENDPOINTS.SET_POSITION_STOP_PROFIT_LOSS}`, body);
}

// API calls to cancel position stop and loss
export function cancelPositionStopProfitLoss(body: SetStopProfitLossPayLoad) {
    return HttpClient.post(`${API_ENDPOINTS.CANCEL_POSITION_STOP_PROFIT_LOSS}`, body);
}

// API calls to modify position margin
export function modifyPositionMargin(body: ModifyPositionMarginPayLoad) {
    return HttpClient.post(`${API_ENDPOINTS.MODIFY_POSITION_MARGIN}`, body);
}

// API calls to modify position margin
export function getLeverage(body: GetLeveragePayload) {
    return HttpClient.post(`${API_ENDPOINTS.GET_LEVERAGE}`, body);
}

// API calls to modify position margin
export function setLeverage(body: SetLeveragePayload) {
    return HttpClient.post(`${API_ENDPOINTS.SET_LEVERAGE}`, body);
}
